import { Injectable } from '@angular/core';
import { AppSettings } from './app.settings';
import { NotificationService } from 'src/app/_helpers/notification.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {
  

  constructor(private notificationService: NotificationService,
    private router: Router) { }
  
  signOut(message: string, showError: boolean = false): void {
    localStorage.clear();
    if(showError) {
      this.notificationService.showError(message);
    } else {
      this.notificationService.showSuccess(message);
    }
    this.router.navigate([AppSettings.LOGIN_ROUTE]);

  }
  public saveToken(token: string): void {
    this.removeToken();
    localStorage.setItem(AppSettings.TOKEN_KEY, btoa(token));
  }

  public getToken(): string {
    let res = localStorage.getItem(AppSettings.TOKEN_KEY);
    if(res==''||res==undefined||res==null) {
      res='';
    }
    return atob(res);
  }
  public removeToken(): void {
    localStorage.removeItem(AppSettings.TOKEN_KEY);
  }
  public saveUserRole(role: string): void {
    localStorage.removeItem(AppSettings.USER_ROLE);
    localStorage.setItem(AppSettings.USER_ROLE, btoa(role?.toUpperCase()));
  }

  public getUserRole(): string {
    let res = localStorage.getItem(AppSettings.USER_ROLE);
    if(res==''||res==undefined||res==null) {
      res='';
    }
    return atob(res);
  }
  public saveUsername(name: string): void {
    localStorage.removeItem(AppSettings.USERNAME);
    localStorage.setItem(AppSettings.USERNAME, btoa(name));
  }

  public getUsername(): string {
    let res = localStorage.getItem(AppSettings.USERNAME);
    if(res==''||res==undefined||res==null) {
      res='';
    }
    return atob(res);
  }
}
